// Lookup helpers for the frontend route manifest. Manifest data + types live
// in ./manifest; this module only reads and resolves.

import { matchPath } from 'react-router';
import {
  routeManifest,
  type FrontendRouteEntry,
  type HeaderTraits,
  type NavSectionKey,
} from './manifest';

/**
 * Returns the manifest entry whose path pattern matches the given pathname,
 * or undefined if no pattern matches.
 */
export const findRouteEntry = (
  pathname: string
): FrontendRouteEntry | undefined =>
  routeManifest.find((entry) =>
    matchPath({ path: entry.path, end: true }, pathname)
  );

/**
 * Resolves header traits for the currently rendered route by matching the
 * manifest's router patterns in order. Patterns with dynamic segments
 * (`:slug`) apply to all concrete URLs under them.
 */
export const getRouteHeaderTraits = (pathname: string): HeaderTraits =>
  findRouteEntry(pathname)?.header ?? {};

/**
 * Returns nav-placed entries for the given section, sorted by explicit order.
 */
export const getNavEntriesForSection = (
  section: NavSectionKey
): FrontendRouteEntry[] =>
  routeManifest
    .filter((entry) => entry.nav?.section === section)
    .sort((a, b) => a.nav!.order - b.nav!.order);

export const isNavPathActive = (pathname: string, path: string) =>
  pathname === path || (path !== '/' && pathname.startsWith(`${path}/`));
